const ptBr = {
  rules: {
    cpfLabel: "Complete el CPF",
    passwordLabel: "La contraseña no puede estar vacía",
    passwordLabelJustNumbers: "La contraseña solo debe contener números.",
    passwordLabel2EqualNumbers:
      "La contraseña no puede tener 2 números iguales seguidos.",
    passwordLabel3EqualNumbers:
      "La contraseña no puede tener 3 números secuenciales.",
    passwordMin6Characteres: "La contraseña debe tener 6 números.",
    emailLabel: "Completa el correo electrónico",
    emailLabelInvalid: "E-mail inválido.",
    cepLabel: "Complete el código postal",
    invalidCepLabel: "Código postal no válido",
    estadoCivilLavel: "El estado civil es obligatorio.",
    estadoCivilComNomeLabel:
      "No es posible cambiar el nombre sin cambiar el estado civil.",
    comprovanteLabel: "Se requiere prueba.",
    telefoneInvalidoLabel: "Teléfono inválido",
    telefoneMaiorQueZeroLabel: "El teléfono no puede comenzar con cero.",
    celularInvalidoLabel: "Teléfono celular inválido",
    celularMaiorQueZeroLabel: "El móvil no puede empezar con cero.",
    nomeObrigatorioLabel: "Se requiere el nombre.",
    logradouroObrigatorioLabel: "El lugar público es obligatorio.",
    ufObrigatorioLabel: "UF es obligatorio.",
    grauInstrucaoObrigatorio: "El título de educación es obligatorio.",
    cidadeLabel: "La ciudad es obligatoria",
    matriculaLabel: "El registro del certificado es obligatorio.",
    observacaoLabel: "La nota es obligatoria.",
    comprovanteLabel: "Se requiere prueba.",
    dataLabel: "Complete la fecha.",
    dataInvalidaLabel: "Fecha invalida.",
    perguntaLabel: "Esta pregunta es obligatoria",
    grauInstrucaoObrigatorioLabel: "Complete el nivel de educación",
  },
  screen: {
    login: {
      contact: `Identificamos en nuestra base de datos que ya existe un registro con este CPF, sin embargo no se proporciona una contraseña para este acceso.
      Comuníquese con RR.HH. de nuestra empresa al (37) 3286 - 2600 para que se pueda actualizar su registro y se implemente una contraseña en su registro.
      ¡Gracias!`,
      messageCardLeft:
        "Bienvenido al Portal de Colaboradores, una forma fácil y práctica de acceder a su información, vales y orientación.",
      serviceNotFound: "Servicio no disponible",
      form1: {
        title: "Acceso al portal",
        label:
          "Para acceder al Portal de Colaboradores, ¡solo informe su CPF y contraseña!",
        passwordLabel: "Contraseña",
        rememberLabel: "Recuérdame",
        btnLoginLabel: "Iniciar sesión",
      },
      dialog1: {
        title: "¡Advertencia!",
        askMessagePassword: "¿Cómo quieres recuperar tu contraseña?",
        btnChangePasswordLabel: "CAMBIAR LA CONTRASEÑA",
        btnCancelLabel: "CANCELAR",
        btnSendLabel: "MANDAR",
        smsOK: "¡WhatsApp enviado satisfactoriamente!",
        smsError: "Vaya ... ¡No se puede enviar el WhatsApp!",
        emailOK: "¡Email enviado con éxito!",
        emailError: "Vaya ... ¡No se puede enviar el correo electrónico!",
        passwordRecoveryError:
          "No hay opción de recuperación de contraseña disponible. Comuníquese con el departamento de Recursos Humanos.",
        passwordOptionsRecovery:
          "Opciones disponibles para la recuperación de contraseña: \n",
        phoneNotValid:
          "No se encontró un número de teléfono válido en su registro.",
        smsNumber:
          "Puede recuperar su contraseña a través de un WhatsApp enviado al número ",
        noSmsNumber: "número no encontrado",
        emailNotFound:
          "No se encontró una dirección de correo electrónico válida en su registro.",
        emailNumber:
          "Puede recuperar su contraseña a través de un correo electrónico enviado a la dirección ",
        emailAndNumberNotFound:
          "No hay opciones de recuperación de contraseña disponibles. Póngase en contacto con la empresa.",
        wrongPass: "Contraseña invalida",
        wrongLogin: "Incapaz de iniciar sesión. \n ",
        cpfNotFound:
          "Hemos identificado que el CPF informado no está en la base de datos, por favor verifique la información proporcionada.",
        passNotFound:
          "Identificamos que el CPF informado no tiene una contraseña registrada en el sistema, por favor comuníquese con la empresa.",
        personNotFound:
          "Identificamos que el CPF informado no está vinculado a ningún empleado registrado en el sistema. Verifique la información proporcionada o comuníquese con la empresa.",
      },
      dialog2: {
        title: "¡Cambiar contraseña!",
        message:
          "Tiene la contraseña de acceso predeterminada, por su seguridad, cambie su contraseña.",
        btnNewPasswordLabel: "Nueva contraseña",
        btnCancelLabel: "Cerrar",
        btnUpdateLabel: "Cambio",
      },
    },
    cgiCardDependente: {
      btnBenefits: "Beneficios",
      benefits: "Beneficios",
      btnClose: "Cerrar",
    },
    footer: {
      name: "Portal de colaboradores",
      version: "Versión",
    },
    navDrawerRight: {
      wellcome: "Bienvenido",
      user: "Usuario",
      btnLogout: "Salir",
    },
    toolbar: {
      wellcome: "Bienvenido",
      start: "Comienzo",
      imageAlt: "Foto de perfil",
      btnChangePass: "Cambiar contraseña",
      btnWarnings: "Avisos",
      showAllWarnigs: "Ver todos los avisos.",
      btnLogout: "Salir",
      labelChangePass: "Nueva contraseña",
      passUpdatedOK: "¡Contraseña alterada con éxito!",
      passUpdatedWrong: "No se puede cambiar la contraseña",
    },
    formDadosCadastrais: {
      nameLavel: "Nombre",
      phoneLabel: "Teléfono",
      celLavel: "Teléfono móvil",
      emailLabel: "E-mail",
      logradouroLabel: "Lugar público",
      enderecoLabel: "Dirección",
      numeroLabel: "Número",
      complementoLabel: "Complemento",
      bairroLabel: "Vecindario",
      cidadeLabel: "Ciudad",
      estadoCivilLabel: "Estado Civil",
      conjugeLabel: "Esposa",
      grauInstrucaoLabel: "Grado de instrucción",
      observacaoLabel: "Observación",
      comprovanteLabelNome: 'Prueba (certificado)',
      comprovanteLabelInfoNome:
        'En este campo, adjunte un comprobante de dirección (factura de luz, factura de agua, etc.) o el certificado de nacimiento del niño o prueba de educación (Diplomas)',        
      comprovanteLabelEndereco: 'Comprobante de domicilio',
      comprovanteLabelInfoEndereco:
        'Adjunte un comprobante de domicilio en este campo (recibo de luz, agua, etc.)',                
      comprovanteLabelEstadoCivil: 'Comprobante de cambio de estado civil (Certificado)',
      comprovanteLabelInfoEstadoCivil:
        'Anexe neste campo um comprovante da alteração do estado civil!',                        
      comprovanteLabelGrauInstrucao: 'Comprovante de Escolaridade',
      comprovanteLabelInfoGrauInstrucao:
        'Anexe neste campo um comprovante da escolaridade (diploma, certidão, etc)',                                
      comprovanteLabelImagem: 'FOTO (nova imagem para o cadastro)',
      comprovanteLabelInfoImagem:
        'Caso desejar, anexe uma nova imagem !',                                                        
      btnCancelar: "Cancelar",
      btnVoltar: "Vuelve",
      btnGravar: "Gravar",
      btnAvancar: "Avance",
      error01Label:
        "Es necesario modificar al menos un campo para solicitar un cambio de registro.",
      error02Label:
        "Su solicitud para cambiar sus datos de registro se ha recibido con éxito. \n Pronto será analizado por los responsables.",
      error03Label: "Error al cargar la prueba de actualización de registro.",
      error04Label:
        "Su solicitud de modificación de los datos de registro no se puede completar porque no fue posible enviar el recibo, comuníquese con la empresa.",
      error05Label:
        "Su solicitud para cambiar sus datos de registro se ha recibido con éxito. \n Pero no fue posible enviar el recibo, comuníquese con la empresa.",
      error06Label: "No fue posible solicitar la actualización del registro.",
    },
    formDependenteResponsivo: {
      nomeLabel: "Nombre",
      sexoLabel: "Sexo",
      masculinoLabel: "Masculino",
      femininoLabel: "Feminino",
      grauDependenciaLabel: "Grado de dependencia",
      cpfLabel: "CPF",
      nascimentoLabel: "Nacimiento",
      nomePaiLabel: "Nombre del Padre",
      nomeMaeLabel: "Nombre de la madre",
      cidadeLabel: "Ciudad",
      numCeridaoLabel: "Certificado no.",
      livroLabel: "Libro",
      folhaLabel: "Hoja",
      matriculaCertidaoLabel: "Inscripción de certificado",
      dataCertidaoLabel: "Fecha del certificado",
      estudanteLabel: "Estudiante",
      necessidadesEspeciaisLabel: "Titular de necesidades especiales",
      tipoNecessidadesEspeciaisLabel: "Tipo de necesidad especial",
      observacaoLabel: "Observación",
      comprovanteLabel: "Prueba",
      btnCancelar: "Cancelar",
      btnVoltar: "Voltar",
      btnGravar: "Gravar",
      btnAvancar: "Avance",
      error01Label:
        "Su solicitud para agregar un dependiente se ha recibido correctamente. Próximamente será analizado por los responsables.",
      error02Label: "Error al cargar el comprobante de dependiente.",
      error03Label:
        "Su solicitud de inclusión de un dependiente no se puede completar porque no fue posible enviar la prueba, comuníquese con la empresa.",
      error04Label:
        "Su solicitud para agregar un dependiente se ha recibido correctamente. Sin embargo, no fue posible enviar el recibo, comuníquese con la empresa.",
      error05Label: "No fue posible solicitar la actualización del registro.",
    },
    avaliacaoClima: {
      descricaoLabel: "Descripción",
      naoSeAplica: "Esa pregunta no se aplica a mí.",
    },
    avisos: {
      tituloLabel: "Avisos",
      possuiAnexosLavel: "Tiene archivos adjuntos.",
      naoTemAvisosLabel: "Aún no tienes avisos.",
    },
    beneficios: {
      tituloLabel: "Beneficios",
      table01: {
        header01: "Descripción",
        header02: "Nombre de la empresa",
        header03: "Valor del mes",
        header04: "Valor acumulado del año",
      },
      error01Label: "Datos no disponibles",
    },
    comprasVarejo: {
      tituloLabel: "Compras minoristas",
      error01Label: "Datos no disponibles",
      table01: {
        header01: "Fecha de venta",
        header02: "Nota fiscal",
        header03: "Valor",
      },
    },
    comprovantes: {
      tituloLabel: "Ingresos",
      string001: "Ref:",
      string002: "Recibo de",
      string003: "disponible",
      string004: "IMPRIMIR",
      string005: "Imprime la prueba en PDF.",
      string006: "Ganancias",
      string007: "Descuentos",
      string008: "Líquido",
      string009: "Detalles",
      string010: "Cerrar",
      string011: 'Base FGTS',
      string012: 'Valor FGTS',
    },
    dadosCadastrais: {
      string001: "Datos personales",
      string002: "Datos contractuales",
      string003: "Actualizar registro",
      string004: "Beneficios",
      string005: "Cerrar",
      string006: "Aviso!",
      string007: "Fone",
      string008: "Teléfono móvil",
      string009: "E-mail",
      string010: "Estado civil",
      string011: "Grado de instrucción",
      string012: "Empresa",
      string013: "CNPJ",
      string014: "Oficina",
      string015: "Unidad",
      string016: "Admisión",
      string017: "Sueldo",
      string018: "Supervisor",
      table01: {
        header01: "Escribe",
        header02: "Descripción",
        header03: "Campo 2",
        header04: "Campo 3",
        header05: "Campo 4",
      },
      error001:
        "Hay una solicitud de actualización de datos de registro pendiente, espere a que se complete la revisión y vuelva a intentarlo.",
      error002:
        "No fue posible actualizar sus datos de registro. Vuelva a intentarlo más tarde o póngase en contacto con la empresa.",
    },
    dependentes: {
      string001: "Dependientes",
      string002: "Agregar dependiente",
      string003: "Aviso!",
    },
    error404: {
      string001: "Página no encontrada.",
      string002: "Página de inicio",
    },
    espelhoDoPonto: {
      string001: "Espejo puntual",
      string002: "Ref:",
      string003: "recibo de",
      string004: "Espejo puntual",
      string005: "Disponible",
      string006: "IMPRIMIR",
      string007: "Imprime la prueba en PDF.",
    },
    faleComRH: {
      string001: "#FaleComRH",
      string002: "Razones",
      string003: "Solicitud",
      string004: "Describe la solicitud",
      string005: "MANDAR",
      string006: "¡Datos enviados con éxito!",
      string007: 'archivo adjunto',
      string008: 'Histórico',
    },
    home: {
      string001: "Funcionalidades",
      string002: "Estadísticas",
      string003: "Algunas estadísticas",
      string004: "de aumento",
      string005: "Actualizado hace 4 minutos",
      string006: "Estadísticas principales",
      string007: "Actualizado hace 10 minutos",
      string008: "Portal de colaboradores",
      string009: "Ingresos",
      string010: "Informe de Rendimentos",
      string011: "Datos de registro",
      string012: "Dependientes",
      string013: "Avisos",
      string014: "Telefonía móvil",
      string015: "Compras minoristas",
      string016: "Punto y PIP",
      string017: "Espejo puntual",
      string018: "Beneficios",
      string019: "Evaluaciones y encuestas",
      string020: "#FalecomRH",
      string021: "Marcas de puntos",
      string022: 'Venta minorista',
      string023: 'Manual del empleado',
      string024: 'horario de vacaciones',
      string025: 'Documentos Firmados',
      string026: 'Ajuste de puntos',
      string027: 'Oportunidades Internas',
      string028: 'Reserva de Restaurante',      
      string029: 'Boleto de la comida',
    },
    informesRendimentos: {
      string001: "Informe de Rendimentos",
      string002: "Ref:",
      string003: "IMPRIMIR",
      string004: "Imprime la prueba en PDF.",
      string005: "Informe de ingresos no encontrado",
      string006: "Informe de ingresos disponibles",
      string007: "Informe de ingresos no disponible",
    },
    marcacoesPonto: {
      string001: "Marcas de puntos",
      string002: "Código de empleado",
      string003: "Unidad",
      string004: "Oficina",
      table01: {
        header01: "Fecha",
        header02: "Dia de la semana",
        header03: "Calendario",
        header04: "Etiquetas",
      },
      string005: 'Horas Extras 50%',
      string006: 'Horas Extras 100%',
      string007: 'Ausencias justificadas',
      string008: 'Ausencias  Injustificadas',
      string009: 'Horas Extras 60%',
      string010: 'Saldo bancario de horas',
    },
    pip: {
      string001: "Punto y PIP",
      string002: "Detalles",
      string003: "Enero",
      string004: "Febrero",
      string005: "Marcha",
      string006: "Abril",
      string007: "Mayo",
      string008: "Junio",
      string009: "Julio",
      string010: "Agosto",
      string011: "septiembre",
      string012: "Octubre",
      string013: "Noviembre",
      string014: "Diciembre",
      string015: "Promedio",
      string016: "Nota final",
      string017: "Fecha de ocurrencia",
      string018: "La cantidad",
    },
    telefonia: {
      string001: "Telefonía móvil",
      string002: "La fecha de inicio",
      string003: "Fecha final",
      table01: {
        header01: "Fecha",
        header02: "Observación",
      },
    },
    cartilha: {
      string001: 'Reglas/Noticias para el Empleado',
      string002: 'IMPRIMIR',
    },    
    programacao: {
      string001: 'Calendario de vacaciones',
    },
    documentos: {
      string001: 'Documentos firmados electrónicamente/À firmar electrónicamente',
      string002: 'IMPRIMIR',
      string003: 'Para firmar',
    },
    agendaAvaliacao: {
      string001: 'Revisiones pendientes',
      string002: 'Responder',
    },
    inclusaoPonto: {
      string001: 'Solicitud de ajuste de puntos',
    },
    oportunidades: {
      string001: 'Lista de oportunidades internas',
    },
    reserva: {
      string001: 'Reserva de Restaurante',
    },
    valerefeicao: {
      string001: 'Boleto de la comida',
      string002: 'La fecha de inicio',
      string003: 'Fecha final',
      table01: {
        header01: 'Situación',
        header02: 'Evento',
        header03: 'Descripción',
        header04: 'Competência',
        header05: 'Valor',
      },
    }
  },
};

export default ptBr;
